import { render } from "./JobTaskButtons.vue?vue&type=template&id=4d530bf6"
import script from "./JobTaskButtons.vue?vue&type=script&lang=js"
export * from "./JobTaskButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__